// GENERATED FILE — do not edit, do not commit (see .gitignore).
// Written by frontend/scripts/generate-version.js on install and on every build.
export const buildInfo = {
  commit: '55ed1c3',
  branch: 'staging',
  buildDate: '2026-11-05T12:37:52.351Z',
  dirty: true,
} as const;
